// Port of api/fuel/app/classes/controller/api/monty/tags/family/update.php
import DB from 'offline/db'
import {
	familyToArray,
	invalid,
	loadOwnedFamily,
	persist,
	sessionUserId,
	unauthorised,
	validateFamilyData
} from '../shared'

export default function(params) {
	var userId = sessionUserId(params)
	var family = false
	var data = params.data || {}

	if (!userId) {
		return unauthorised()
	}

	family = loadOwnedFamily(userId, params.family)
	if (!family) {
		return unauthorised()
	}

	data.context = parseInt(family.family_context, 10) || 0
	if (!validateFamilyData(data)) {
		return invalid()
	}

	DB.run('UPDATE tag_family SET family_public = ?, family_style = ?, family_type = ?, family_name = ?, family_fore = ?, family_colour = ? WHERE family_id = ?', [
		parseInt(data.public, 10) || 0,
		parseInt(data.style, 10) || 0,
		parseInt(data.type, 10) || 0,
		String(data.name || '').trim(),
		String(data.fore || ''),
		String(data.colour || ''),
		parseInt(family.family_id, 10) || 0
	])

	DB.run('UPDATE tag SET tag_public = ? WHERE family_id = ?', [
		parseInt(data.public, 10) || 0,
		parseInt(family.family_id, 10) || 0
	])

	if (parseInt(data.style, 10) || 0) {
		DB.run('UPDATE tag SET tag_fore = ?, tag_colour = ? WHERE family_id = ?', [
			String(data.fore || ''),
			String(data.colour || ''),
			parseInt(family.family_id, 10) || 0
		])
	}

	var rows = DB.query('SELECT * FROM tag_family WHERE family_id = ?', [family.family_id])
	return persist(familyToArray(rows[0]))
}
